import { ConditionalPartial } from '../../../../utils';

import { CreateWarehouseProductManagementRequestDto } from './create-warehouse-product-management.request.dto';

/**
 * DTO for updating warehouse product management configuration
 * All fields are optional for partial updates
 */
export class UpdateWarehouseProductManagementRequestDto extends ConditionalPartial(
    CreateWarehouseProductManagementRequestDto,
) {}
